import {IHttpService, IRequestShortcutConfig} from "angular";
import {TradeIdeaRecords, TradeIdeasRecord} from "../models/TradeIdeaRecord";
import {CurrentUserService} from "../../services/user/CurrentUserService";

export interface LatestTradingIdeasParams {
    readonly confidence?: number | null;
    readonly includeInactive?: boolean | null;
}

export class TradingIdeasService {

    public static id = "tradingIdeasService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService,
                       private readonly currentUserService: CurrentUserService) {

    }

    public async list(): Promise<TradeIdeaRecords> {
        const url = `/tradefloor/api/trading-ideas/latest`;
        const config: IRequestShortcutConfig = {
        };

        const confidence = this.currentUserService.isSupport() ? 0.3 : null;
        config.params = {
            confidence
        } as LatestTradingIdeasParams;
        
        const response = await this.$http.get<TradeIdeasRecord>(url, config);
        const data = response.data!;
        return data.ironCondors;
    }
}
